export { default } from "./Redirect"
